import { render, staticRenderFns } from "./pre_mode_tan.vue?vue&type=template&id=2a49ae14&scoped=true"
import script from "./pre_mode_tan.vue?vue&type=script&lang=js"
export * from "./pre_mode_tan.vue?vue&type=script&lang=js"
import style0 from "./pre_mode_tan.vue?vue&type=style&index=0&id=2a49ae14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49ae14",
  null
  
)

export default component.exports